<template>
  <div class="Error">
    <img src="../assets/img/error.svg" class="ErrorImage" />
    <h2 class="text-error text-center">İşleminiz Gerçekleşmedi</h2>
    <div class="content-xl">
      <div class="text-center text-coolgrey mb-60">
        <template v-if="errorType === 1">
          Kartınız banka sisteminde bulunamadı, lütfen kartınızın ilk 6 ve son 4 hanesini, güvenlik numarasını ve
          TC Kimlik numaranızı doğrıu girdiğinizden emin olunuz.
        </template>
        <template v-else>
          <div
            class="text-bold"
          >Limitiniz bu işlem için yeterli değildir. Başka bir kart ile tekrar deneyiniz.</div>
          <div>
            İşleminiz onaylanmamıştır. Başka bir kart seçmek için ‘’
            <span
              class="text-bold"
            >Kart Seçim</span>’’,
            işlemi iptal etmek için ‘’
            <span class="text-bold">İptal</span>’’ butonuna basınız
          </div>
        </template>
      </div>
      <div class="ErrorButtons">
        <div>
          <button id="BtnGoToCards" @click="onCardClick">Kart Seçim</button>
        </div>
        <div>
          <button id="BtnCancel" class="outline error" @click="onCancel">İptal</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Error",
  data: () => ({
    errorType: 2
  }),
  methods: {
    onCardClick() {
      this.$router.push("/select-card");
    },
    onCancel() {}
  }
};
</script>